import * as THREE from 'three';
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

export function createStudio(scene, renderer, materials) {
  let photoActive = false, contrast = false;
  const originalFloorColor = materials.floor.color.clone();
  scene.background = new THREE.Color('#c3ccc7');
  const pmrem = new THREE.PMREMGenerator(renderer), room = new RoomEnvironment();
  const env = pmrem.fromScene(room); scene.environment = env.texture; scene.environmentIntensity = .9;
  room.dispose(); pmrem.dispose();
  const floor = new THREE.Mesh(new THREE.PlaneGeometry(250, 250), materials.floor);
  floor.rotation.x = -Math.PI / 2; floor.position.y = -.008; floor.receiveShadow = true; scene.add(floor);
  const uv = floor.geometry.attributes.uv; for (let i = 0; i < uv.count; i++) uv.setXY(i, uv.getX(i) * 200, uv.getY(i) * 200);
  const grid = new THREE.GridHelper(120, 120, '#8b9e97', '#a2b0a9'); grid.position.y = -.006;
  grid.material.transparent = true; grid.material.opacity = .16; scene.add(grid);
  scene.add(new THREE.HemisphereLight('#f7faf6', '#718073', 2));
  const sun = new THREE.DirectionalLight('#fff3de', 3); sun.position.set(-7, 12, 8); scene.add(sun);
  sun.castShadow = !materials.software; sun.shadow.mapSize.set(1024, 1024); sun.shadow.normalBias = .015;
  const fill = new THREE.DirectionalLight('#d8e9f1', 1.8); fill.position.set(6, 5, -7); scene.add(fill);
  const updateBackdrop = () => {
    scene.background = photoActive ? null : new THREE.Color(contrast ? '#46534e' : '#c3ccc7');
    materials.floor.color.copy(contrast ? new THREE.Color('#29332e') : originalFloorColor);
  };
  return {
    setFinish: finish => {
      const color = new THREE.Color(finish.hex);
      // Change the inspection background, never the supplied finish or geometry.
      contrast = .2126 * color.r + .7152 * color.g + .0722 * color.b > .55;
      updateBackdrop();
    },
    get backdropMode() { return photoActive ? 'photo' : contrast ? 'contrast' : 'standard'; },
    setPhotoMode: active => {
      photoActive = active; floor.visible = grid.visible = !active; updateBackdrop();
      // House photos already contain their lighting; avoid the studio's bright
      // inspection reflections washing dark frame finishes into light gray.
      scene.environmentIntensity = active ? .3 : .9; sun.intensity = active ? 1.2 : 3; fill.intensity = active ? .6 : 1.8;
    },
    fit: (center, radius) => {
      sun.target.position.copy(center); scene.add(sun.target);
      sun.position.copy(center).add(new THREE.Vector3(-radius, radius * 2, radius));
      Object.assign(sun.shadow.camera, { left: -radius, right: radius, top: radius, bottom: -radius, far: radius * 8 }); sun.shadow.camera.updateProjectionMatrix();
    },
    dispose: () => { env.dispose(); floor.geometry.dispose(); grid.geometry.dispose(); grid.material.dispose(); },
  };
}